<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Сведения о проверках соблюдения требований нормативных документов при строительстве
    </div>
    <n-table :columns="columns" />
    <p>* При посещении объектов, допуск на которые ограничен в соответствии с законодательством</p>
  </div>
</template>

<script>
export default {
  name: 'MainChapter7',
  data: () => ({
    columns: [
      { name: 'one', title: '№', },
      { name: 'one', title: 'Наименование контролирующего (надзорного) органа', },
      { name: 'one', title: 'Номер и дата выдачи предписания (вид и реквизиты документа, предусмотренного законодательством для допуска на объект*)', },
      { name: 'one', title: 'Должность проверяющего, фамилия, инициалы (состав группы проверяющих), руководителя проверки', },
      { name: 'one', title: 'Дата начала и окончания проверки', },
      { name: 'one', title: 'Наименование документа по результатам проверки и дата его составления', },
      { name: 'one', title: 'Подпись проверяющего (руководителя проверки)', },
      { name: 'one', title: 'Примечание', },
    ],
  }),
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
